// src/pages/shop/Shop.js
// import pages
import React, { useState, useEffect } from "react";
import FooterB from "../layout/FooterB";
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import HeroSection from "../layout/HeroSection";
import ShopIndexSection from "../layout/ShopIndexSection";
import BookSection from "../layout/BookSection";
import SimpleTextSection from "../layout/SimpleTextSection";
import { getShopPage } from "../../sanityClient";

// import style
import "../../style/pages/shop/shop.scss";

const componentMap = {
  heroSection: HeroSection,
  indexSection: ShopIndexSection,
  bookSection: BookSection,
  simpleTextSection: SimpleTextSection,
  footerB: FooterB,
  subHeader: SubHeader,
  subFooter: SubFooter,
  // Add more components as needed
};

const Shop = () => {
  const [pageData, setPageData] = useState({
    pageSections: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        const data = await getShopPage();
        if (data) {
          setPageData(data);
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  const renderSection = (section, index) => {
    const SectionComponent = componentMap[section._type];

    if (!SectionComponent) {
      console.warn(`Unknown section type: ${section._type}`);
      return null;
    }

    switch (section._type) {
      case 'heroSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          subTitle={section.subTitle}
          backgroundColorClass={section.backgroundColorClass}
          linkPath={section.linkPath}
          enContent={section.enContent}
          jpContent={section.jpContent}
          questionLinkText={section.questionLink}
          questionLinkJpText={section.questionLinkJp}
        />
      case 'indexSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          titleJP={section.titleJP}
          subtitles={section.subtitles} // dynamic array of subtitles
          items={section.items}         // dynamic array of items
          bottomText={section.bottomText}
          bottomTextJP={section.bottomTextJP}
        />;
      case 'bookSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          titleJP={section.titleJP}
          id={section.id}
          isTitleBGYellow={section.isTitleBGYellow}
          items={section.items}
        />;
      case 'simpleTextSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          titleJP={section.titleJP}
        />;
      case 'footerB':
        return <SectionComponent key={section._key || index} />;
      case 'subHeader':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      case 'subFooter':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      default:
        return null;
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional loading state
  }

  return (
    <div className="shop-section">
      {pageData.pageSections && pageData.pageSections.length > 0 ? (
        pageData.pageSections.map((section, index) => renderSection(section, index))
      ) : (
        <>
          <div className="error-container container main-section">
            <div className="responsive-main-section">
              <div className="title-section background-blue">
                <div className="title-link">
                  <div className="title font-amaticsc-bold">Oops!</div>
                  <div className="sub-title font-zenkurenaido">おっと！</div>
                </div>
              </div>
              <div className="content-section">
                <div className="en-content font-outfit-bold">
                  Something went wrong while loading the shop. Please try again later.
                  <br /><br />
                  Have a question for Ben-sensei? Feel free to ask it <a href="/question" className="en-question-link">here!</a>
                </div>
                <div className="jp-content font-kleeone">
                  ページの読み込み中に問題が発生しました。しばらくしてからもう一度お試しください。
                  <br /><br />
                  ベン先生に質問がありますか？ ぜひ<a href="/question" className="jp-question-link">こちらから</a>質問してください！
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Shop;